import React, { useState } from 'react';


export default function RegisterToken() {

    const [ token, setToken ] = useState({
        protocol: 'plot',
        id: '',
        owneraddress: '',
        metadataaddress: '',
        plotmetadata: {
            plot: '',
            area: '',
            co2: '',
            species: '',
            ccoord: '',
            municipality: '',
            url: '',
        },
        co2metadata: {
            area: '',
            co2: '',
            plots: '',
            owner: '',
            expiry: '',
            url: '',
        },
    });

    const [showModal, setShowModal] = useState(false);
    const [command, setCommand] = useState('');

    const handleChange = (e) => {
        setToken({ ...token, [e.target.name]: e.target.value });
    };

    const handleMetadataChange = (e) => {
        setToken({ 
            ...token, 
            [`${token.protocol}metadata`]: { 
                ...token[`${token.protocol}metadata`], 
                [e.target.name]: e.target.value
            }
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let metadata = '';
        for (var [key, value] of Object.entries(token[`${token.protocol}metadata`])) {
            metadata += key+': '+value+',';
        };
        metadata = metadata.substr(0, metadata.length - 1);
        setCommand(`nftoken register ${token.protocol} ${token.nftid} ${token.owneraddress} ${token.metadataaddress} '{${metadata}}'`);
        setShowModal(true);
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(command);
        setShowModal(true);
    }

    return(
	<>
        <header className="bg-white shadow">
            <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl font-bold leading-tight text-gray-900">
                Register a new Token
                </h1>
            </div>
        </header>
        <main>      
            <div className="flex items-center justify-center max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                <div className="mt-10 sm:mt-0">
                    <div className="mt-5 md:mt-0 md:col-span-2">
                        <form action="#" method="POST" onSubmit={ handleSubmit }>
                            <div className="shadow overflow-hidden sm:rounded-md">
                                <div className="px-4 py-5 bg-white sm:p-6">
                                    <div className="grid grid-col-3 gap-3">
                                        <div className="col-span-full">
                                            <label htmlFor="protocol" className="block text-sm font-medium text-gray-700">Protocol</label>
                                            <select 
                                                id="protocol" 
                                                name="protocol" 
                                                autoComplete="off" 
                                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                required
                                                onChange={ handleChange }
                                            >
                                                <option>plot</option>
                                                <option>co2</option>
                                            </select>
                                        </div>
                                        <div className="col-span-full">
                                            <label htmlFor="nftid" className="block text-sm font-medium text-gray-700">Token's Unique Id</label>
                                            <input 
                                                type="text" 
                                                name="nftid" 
                                                id="nftid" 
                                                autoComplete="off" 
                                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                required
                                                onChange={ handleChange }
                                            />
                                        </div>
                                        <div className="col-span-full">
                                            <label htmlFor="owneraddress" className="block text-sm font-medium text-gray-700">Token Owner Address</label>
                                            <input 
                                                type="text" 
                                                name="owneraddress" 
                                                id="owneraddress" 
                                                autoComplete="off" 
                                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                required
                                                onChange={ handleChange }
                                            />
                                        </div>
                                        <div className="col-span-full">
                                            <label htmlFor="metadataaddress" className="block text-sm font-medium text-gray-700">Token Metadata Admin Address</label>
                                            <input 
                                                type="text" 
                                                name="metadataaddress" 
                                                id="metadataaddress" 
                                                autoComplete="off" 
                                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                required
                                                onChange={ handleChange }
                                            />
                                        </div>
                                        <div className="col-span-full my-2">
                                            <label className="block text-md font-bold text-gray-700">Metadata:</label>
                                        </div>
                                        <div className='grid grid-col-3 gap-3 col-span-12'>
                                            { token.protocol === 'plot' ? 
                                            <>
                                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                    <label htmlFor="plot" className="block text-sm font-medium text-gray-700">Plot</label>
                                                    <input type="text" name="plot" id="plot" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                    required
                                                    onChange={ handleMetadataChange }
                                                    />
                                                </div>
                                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                    <label htmlFor="area" className="block text-sm font-medium text-gray-700">Area</label>
                                                    <input type="text" name="area" id="area" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                    required
                                                    onChange={ handleMetadataChange }
                                                    />
                                                </div>
                                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                    <label htmlFor="co2" className="block text-sm font-medium text-gray-700">CO2</label>
                                                    <input type="text" name="co2" id="co2" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                    required
                                                    onChange={ handleMetadataChange }
                                                    />
                                                </div>
                                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                    <label htmlFor="species" className="block text-sm font-medium text-gray-700">Species</label>
                                                    <input type="text" name="species" id="species" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                    required
                                                    onChange={ handleMetadataChange }
                                                    />
                                                </div>
                                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                    <label htmlFor="ccoord" className="block text-sm font-medium text-gray-700">Central Coordinates</label>
                                                    <input type="text" name="ccoord" id="ccoord" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                    required
                                                    onChange={ handleMetadataChange }
                                                    />
                                                </div>
                                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                    <label htmlFor="municipality" className="block text-sm font-medium text-gray-700">Municipality</label>
                                                    <input type="text" name="municipality" id="municipality" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                    required
                                                    onChange={ handleMetadataChange }
                                                    />
                                                </div>
                                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                    <label htmlFor="url" className="block text-sm font-medium text-gray-700">URL</label>
                                                    <input type="text" name="url" id="url" autoComplete="offpostal-code" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                    required
                                                    onChange={ handleMetadataChange }
                                                    />
                                                </div>
                                            </>
                                            : 
                                            <>
                                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                    <label htmlFor="area" className="block text-sm font-medium text-gray-700">Area</label>
                                                    <input type="text" name="area" id="area" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                    required
                                                    onChange={ handleMetadataChange }
                                                    />
                                                </div>
                                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                    <label htmlFor="co2" className="block text-sm font-medium text-gray-700">CO2</label>
                                                    <input type="text" name="co2" id="co2" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                    required
                                                    onChange={ handleMetadataChange }
                                                    />
                                                </div>
                                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                    <label htmlFor="staplotste" className="block text-sm font-medium text-gray-700">Plots</label>
                                                    <input type="text" name="plots" id="plots" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                    required
                                                    onChange={ handleMetadataChange }
                                                    />
                                                </div>
                                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                    <label htmlFor="owner" className="block text-sm font-medium text-gray-700">Owner</label>
                                                    <input type="text" name="owner" id="owner" className="mt-1  focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                    required
                                                    onChange={ handleMetadataChange }
                                                    />
                                                </div>                                            
                                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                    <label htmlFor="expiry" className="block text-sm font-medium text-gray-700">Expiry Date</label>
                                                    <input type="text" name="expiry" id="expiry" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                    required
                                                    onChange={ handleMetadataChange }
                                                    />
                                                </div>
                                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                    <label htmlFor="url" className="block text-sm font-medium text-gray-700">URL</label>
                                                    <input type="text" name="url" id="url" autoComplete="offpostal-code" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                                                    required
                                                    onChange={ handleMetadataChange }
                                                    />
                                                </div>
                                            </> }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                <button 
                                    type="submit" 
                                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                Register Token
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {showModal ? (
            <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-auto my-6 mx-auto max-w-3xl">
                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    {/*header*/}
                    <div className="flex items-start justify-between p-5 border-b border-solid border-gray-300 rounded-t">
                    <h3 className="text-3xl font-semibold">
                        NFT Register Command
                    </h3>
                    <button
                        className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                        onClick={() => setShowModal(false)}
                    >
                        <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                        ×
                        </span>
                    </button>
                    </div>
                    {/*body*/}
                    <div className="relative p-6 flex-auto">
                    <p className="my-4 text-gray-600 text-lg leading-relaxed break-normal">
                        { command }
                    </p>
                    </div>
                    {/*footer*/}
                    <div className="flex items-center justify-end p-6 border-t border-solid border-gray-300 rounded-b">
                    <button
                        className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                        style={{ transition: "all .15s ease" }}
                        onClick={() => setShowModal(false)}
                    >
                        Close
                    </button>
                    <button
                        className="bg-indigo-600 text-white focus:ring focus:ring-indigo-600 active:bg-green-700 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                        style={{ transition: "all .15s ease" }}
                        onClick={ handleCopy }
                    >
                        Copy to Clipboard
                    </button>
                    </div>
                </div>
                </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
        ) : null}
        </main>
	</>
    );
}
